module.exports = __webpack_public_path__ + "static/media/ico-everything.49d86af0.svg";